export default {
  rigid_flex_selector    : 'Rigid Flex',
  part_number            : '',
  revision               : '',
  quantities             : ['10', '25', '50', '100'],
  board_length           : '',
  board_width            : '',
  material_type          : 'FR4',
  number_of_layers       : '2',
  number_of_flex_layers  : '1',
  material_thickness     : '0.006',
  material_thickness_flex: '0.006',
  finish_plating         : 'ENIG',
  copper_outers          : '0.8 oz',
  solder_sides           : 'Top Side',
  solder_color           : 'green',
  silkscreen_sides       : 'Top Side',
  silkscreen_color       : 'White',
  flex_outer_layer       : '0',
  special_instructions   : '',
};
